export default __webpack_public_path__ + "static/media/twitter-original.01b7adc1.svg";